<template>
	<section class="main-content contentblocks-section">
		<slot name="extra-content" />
		<div
			v-for="(block, idx) in contentblocks"
			:key="block.ID"
			class="row block-item"
			:class="{ even: idx % 2 == 0 }"
		>
			<div class="columns column6">
				<div class="content-wrapper">
					<div class="content">
						<h3>{{ block.header }}</h3>
						<div v-parse-links v-html="block.content" />
					</div>
				</div>
			</div>
			<div class="columns column6">
				<picture>
					<source :srcset="block.imageWebp" type="image/webp" />
					<source :srcset="block.image" />
					<img :src="block.image" :alt="block.imageAlt" loading="lazy" />
				</picture>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	contentblocks: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblock-section {
	padding: 50px 0 100px;
}

.block-item {
	display: flex;
	justify-content: center;
	align-items: stretch;
	overflow: hidden;
	padding: 0 20px;
	margin: 40px auto;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.column6 {
		padding: 0;
		display: flex;
		justify-content: center;
		align-items: stretch;
	}

	.content {
		background: rgb(227 227 239 / 90%);
		padding: 75px;
		box-shadow: 0 20px 30px rgb(0 0 0 / 15%);
		z-index: 2;
		margin-right: -40px;
	}

	.content-wrapper {
		padding: 50px 0;
		z-index: 2;
		display: flex;
		align-items: center;
	}
}

.block-item.even {
	flex-direction: row-reverse;

	.content {
		margin-right: 0;
		margin-left: -40px;
	}
}

@media (max-width: 960px) {
	.block-item,
	.block-item:nth-child(even),
	.block-item.even {
		flex-direction: column-reverse;

		.content-wrapper {
			padding: 0;
		}

		.content {
			margin-left: 0;
			margin-right: 0;
			padding: 50px;
		}
	}
}

@media (max-width: 600px) {
	.block-item,
	.block-item:nth-child(even),
	.block-item.even {
		.content {
			padding: 40px 30px 30px;
		}
	}
}
</style>
